import { OrderCategory } from '@contracts/order/OrderCategory';
import { string } from 'yup';

export const OrderCategorySchema = string()
  .oneOf(Object.values(OrderCategory))
  .defined();
